module.exports = __webpack_public_path__ + "static/media/nature.209485de.mp3";